import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Layout, Avatar, List, Row, Col, Tabs, Badge } from "antd";
import { BellOutlined, UserOutlined } from "@ant-design/icons";
import { logout } from "@/redux/auth/actions";
import uniqueId from "@/utils/uinqueId";
import { useNavigate } from "react-router-dom";
import CustomDropdown from "@/components/CustomDropdown";
import {
  selectAuthCurrent,
  selectUserNotifications,
} from "@/redux/auth/selectors";
import { navigateToPage, removeUnderscoreBetweenWords } from "@/utils/helpers";
import NotificationList from "@/components/NotificationList";
import { roles } from "@/utils/constant";
import ImageComponent from "@/components/ImageComponent";

const { Header } = Layout;

export default function HeaderContent() {
  const auth = useSelector(selectAuthCurrent);
  const userNotifications = useSelector(selectUserNotifications);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const INFO_TYPE = "info";
  const { shopProfile } = useSelector((state) => state?.auth);

  const notificationCounter = () => {
    const counter = {
      totalCount: 0,
      notificationCount: 0,
      messageCount: 0,
    };
    const unreadNotifications = userNotifications?.filter(
      (item) => item?.status === true
    );

    unreadNotifications?.map((item) => {
      if (item?.type === INFO_TYPE) {
        counter.notificationCount += 1;
      } else {
        counter.messageCount += item?.messageCount;
      }
    });
    return {
      ...counter,
      totalCount: counter.notificationCount + counter.messageCount,
    };
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const shopOwnerItems = [
    {
      key: `${uniqueId()}`,
      label: "Profile",
      onClick: () =>
        navigateToPage(
          "/profile",
          {
            id: auth?.user?.id,
            isAdmin: true,
            isProfilePage: true,
          },
          navigate
        ),
    },
    {
      key: `${uniqueId()}`,
      label: "Shop Profile",
      onClick: () =>
        navigateToPage(
          "/shop-profile",
          { isShopOwner: true, shopProfile },
          navigate
        ),
    },
    {
      key: `${uniqueId()}`,
      label: "Logout",
      onClick: () => dispatch(logout(navigate)),
    },
  ];

  const writerItems = [
    {
      key: `${uniqueId()}`,
      label: "Profile",
      onClick: () =>
        navigateToPage(
          "/profile",
          {
            id: auth?.user?.id,
            isWriter: true,
            isAdmin: true,
            isProfilePage: true,
          },
          navigate
        ),
    },
    {
      key: `${uniqueId()}`,
      label: "Logout",
      onClick: () => dispatch(logout(navigate)),
    },
  ];

  const adminItems = [
    {
      key: `${uniqueId()}`,
      label: "Logout",
      onClick: () => dispatch(logout(navigate)),
    },
  ];

  const currentItems = {
    [roles.SHOPOWNER]: shopOwnerItems,
    [roles.APPRAISALWRITER]: writerItems,
    [roles.ADMIN]: adminItems,
  };

  const tabItems = [
    {
      key: "1",
      label: (
        <Badge count={notificationCounter()?.notificationCount} size="small">
          Notifications
        </Badge>
      ),
      children: <NotificationList selectedTab={1} />,
    },
    {
      key: "2",
      label: (
        <Badge count={notificationCounter()?.messageCount} size="small">
          Messages
        </Badge>
      ),
      children: <NotificationList selectedTab={2} />,
    },
  ];

  const handleDropdownOpenChange = (flag) => {
    setIsDropdownOpen(flag);
  };

  const menu = () => (
    <div className="notification-menu-box">
      <Tabs centered defaultActiveKey="1">
        <Tabs.TabPane
          tab={
            <Badge
              style={styles.notificationBadge}
              size="small"
              count={notificationCounter()?.notificationCount}
            >
              Notifications
            </Badge>
          }
          key="1"
        >
          <NotificationList
            selectedTab={1}
            closeDropdown={() => setIsDropdownOpen(false)}
          />
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={
            <Badge
              size="small"
              style={styles.notificationBadge}
              count={notificationCounter()?.messageCount}
            >
              Messages
            </Badge>
          }
          key="2"
        >
          <NotificationList
            selectedTab={2}
            closeDropdown={() => setIsDropdownOpen(false)}
          />
        </Tabs.TabPane>
      </Tabs>
    </div>
  );

  return (
    <Header className="header-container">
      <span className="header-user-info-container">
        <p className="header-name">{auth?.user?.name}</p>
        <p className="header-role">
          {removeUnderscoreBetweenWords(auth?.user?.role)}
        </p>
      </span>
      <CustomDropdown
        items={currentItems[auth?.user?.role]}
        icon={
          auth?.user?.profileImage ? (
            <ImageComponent
              src={auth?.user?.profileImage}
              isPreview={false}
              width={32}
              height={32}
              alt={"user profile picture"}
              className="userProfilePicture"
            />
          ) : (
            <Avatar
              className="avatar"
              style={{ margin: 0 }}
              icon={<UserOutlined />}
            />
          )
        }
      />
      {auth?.user?.role !== roles.ADMIN && (
        <CustomDropdown
          icon={
            <Badge count={notificationCounter()?.totalCount}>
              <Avatar className="avatar" icon={<BellOutlined />} />
            </Badge>
          }
          overlay={menu}
          open={isDropdownOpen}
          onOpenChange={handleDropdownOpenChange}
        />
      )}
    </Header>
  );
}

const styles = {
  notificationBadge: { position: "absolute", top: "-3px", right: "-2px" },
};
